"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrillValidationMessages = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var model_1 = require("../../../model");
var sdk_model_1 = require("@gooddata/sdk-model");
var commonReplacements = {
    b: function (chunks) { return react_1.default.createElement("b", null, chunks); },
    i: function (chunks) { return react_1.default.createElement("i", null, chunks); },
};
var localizationMessages = react_intl_1.defineMessages({
    invalidDrillTitle: { id: "messages.dashboard.invalidDrills.title" },
    invalidDrillBody: { id: "messages.dashboard.invalidDrills.body.modern" },
    invalidUrlDrillTitle: { id: "messages.dashboard.invalidCustomUrlDrills.title" },
    invalidUrlDrillBody: { id: "messages.dashboard.invalidCustomUrlDrills.body.modern" },
    showMore: { id: "messages.dashboard.expandable.showMore" },
    showLess: { id: "messages.dashboard.expandable.showLess" },
});
var DRILL_MESSAGE_ID = "invalid_drill_message";
var URL_DRILL_MESSAGE_ID = "invalid_url_drill_message";
function useDrillValidationMessages() {
    var intl = react_intl_1.useIntl();
    var dispatch = model_1.useDashboardDispatch();
    var allWidgets = model_1.useDashboardSelector(model_1.selectWidgetsMap);
    var invalidDrillWidgetRefs = model_1.useDashboardSelector(model_1.selectInvalidDrillWidgetRefs);
    var invalidUrlDrillWidgetRefs = model_1.useDashboardSelector(model_1.selectInvalidUrlDrillParameterWidgetWarnings);
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var messages = react_1.useMemo(function () {
        if (!isInEditMode) {
            return [];
        }
        var invalidDrillWidgets = compact_1.default(invalidDrillWidgetRefs.map(function (ref) { return allWidgets.get(ref); }).filter(sdk_model_1.isWidget));
        var invalidUrlDrillWidgets = compact_1.default(invalidUrlDrillWidgetRefs.map(function (ref) { return allWidgets.get(ref); }).filter(sdk_model_1.isWidget));
        return compact_1.default([
            invalidDrillWidgets.length > 0 && {
                id: DRILL_MESSAGE_ID,
                type: "warning",
                node: intl.formatMessage(localizationMessages.invalidDrillTitle, commonReplacements),
                errorDetail: intl.formatMessage(localizationMessages.invalidDrillBody, tslib_1.__assign({ listOfWidgetTitles: invalidDrillWidgets.map(sdk_model_1.widgetTitle).join(", ") }, commonReplacements)),
                showMore: intl.formatMessage(localizationMessages.showMore),
                showLess: intl.formatMessage(localizationMessages.showLess),
            },
            invalidUrlDrillWidgets.length > 0 && {
                id: URL_DRILL_MESSAGE_ID,
                type: "warning",
                node: intl.formatMessage(localizationMessages.invalidUrlDrillTitle, commonReplacements),
                errorDetail: intl.formatMessage(localizationMessages.invalidUrlDrillBody, tslib_1.__assign({ listOfWidgetTitles: invalidUrlDrillWidgets.map(sdk_model_1.widgetTitle).join(", ") }, commonReplacements)),
                showMore: intl.formatMessage(localizationMessages.showMore),
                showLess: intl.formatMessage(localizationMessages.showLess),
            },
        ]);
    }, [isInEditMode, invalidDrillWidgetRefs, invalidUrlDrillWidgetRefs, intl, allWidgets]);
    var removeMessage = react_1.useCallback(function (id) {
        if (id === DRILL_MESSAGE_ID) {
            dispatch(model_1.uiActions.resetInvalidDrillWidgetRefs());
        }
        if (id === URL_DRILL_MESSAGE_ID) {
            dispatch(model_1.uiActions.resetAllInvalidCustomUrlDrillParameterWidgetsWarnings());
        }
    }, [dispatch]);
    var removeAllMessages = react_1.useCallback(function () {
        dispatch(model_1.uiActions.resetInvalidDrillWidgetRefs());
        dispatch(model_1.uiActions.resetAllInvalidCustomUrlDrillParameterWidgetsWarnings());
    }, [dispatch]);
    return {
        messages: messages,
        removeMessage: removeMessage,
        removeAllMessages: removeAllMessages,
    };
}
exports.useDrillValidationMessages = useDrillValidationMessages;
//# sourceMappingURL=useDrillValidationMessages.js.map